import React from 'react';

import Input from '../../../components/ui/Input';
import Select from '../../../components/ui/Select';
import Button from '../../../components/ui/Button';

const FilterBar = ({ 
  searchQuery, 
  onSearchChange, 
  selectedType, 
  onTypeChange, 
  selectedStatus, 
  onStatusChange,
  selectedIssuer,
  onIssuerChange,
  onClearFilters,
  credentialTypes,
  issuers
}) => {
  const statusOptions = [
    { value: 'all', label: 'All Status' },
    { value: 'verified', label: 'Verified' },
    { value: 'pending', label: 'Pending' },
    { value: 'expired', label: 'Expired' }
  ];

  const typeOptions = [
    { value: 'all', label: 'All Types' },
    ...credentialTypes?.map(type => ({
      value: type,
      label: type?.charAt(0)?.toUpperCase() + type?.slice(1)
    }))
  ];

  const issuerOptions = [
    { value: 'all', label: 'All Issuers' },
    ...issuers?.map(issuer => ({
      value: issuer,
      label: issuer
    }))
  ];

  const hasActiveFilters = selectedType !== 'all' || selectedStatus !== 'all' || selectedIssuer !== 'all' || searchQuery;

  return (
    <div className="bg-card border border-border rounded-lg p-6 mb-6">
      <div className="flex items-center justify-between mb-4">
        <h3 className="font-semibold text-foreground">Filter Credentials</h3>
        {hasActiveFilters && (
          <Button
            variant="ghost"
            size="sm"
            iconName="X"
            iconPosition="left"
            onClick={onClearFilters}
          >
            Clear Filters
          </Button>
        )}
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
        {/* Search */}
        <div className="lg:col-span-2">
          <Input
            type="search"
            placeholder="Search credentials..."
            value={searchQuery}
            onChange={(e) => onSearchChange(e?.target?.value)}
            className="w-full"
          />
        </div>

        {/* Type Filter */}
        <Select
          placeholder="Filter by type"
          options={typeOptions}
          value={selectedType}
          onChange={onTypeChange}
        />

        {/* Status Filter */}
        <Select
          placeholder="Filter by status"
          options={statusOptions}
          value={selectedStatus}
          onChange={onStatusChange}
        />

        {/* Issuer Filter - Full width on mobile */}
        <div className="md:col-span-2 lg:col-span-2">
          <Select
            placeholder="Filter by issuer"
            options={issuerOptions}
            value={selectedIssuer}
            onChange={onIssuerChange}
            searchable
          />
        </div>
      </div>
      {/* Quick Filter Buttons */}
      <div className="flex flex-wrap gap-2 mt-4 pt-4 border-t border-border">
        <span className="text-sm text-muted-foreground mr-2">Quick filters:</span>
        <Button
          variant="ghost"
          size="sm"
          iconName="AlertTriangle"
          iconPosition="left"
          onClick={() => onStatusChange('expired')}
          className="text-error hover:text-error hover:bg-error/10"
        >
          Expired
        </Button>
        <Button
          variant="ghost"
          size="sm"
          iconName="Clock"
          iconPosition="left"
          onClick={() => onStatusChange('pending')}
          className="text-warning hover:text-warning hover:bg-warning/10"
        >
          Pending
        </Button>
        <Button
          variant="ghost"
          size="sm"
          iconName="Shield"
          iconPosition="left"
          onClick={() => onTypeChange('vaccination')}
        >
          Vaccinations
        </Button>
        <Button
          variant="ghost"
          size="sm"
          iconName="GraduationCap"
          iconPosition="left"
          onClick={() => onTypeChange('training')}
        >
          Training
        </Button>
      </div>
    </div>
  );
};

export default FilterBar;